import * as actions from "./systemConfigActionType"

export const systemConfigPreview = (payload?: any): actions.SystemConfigRequest => {
    return {
        type: actions.SYSTEM_CONFIG_PREVIEW,
        payload
    }
}

export const systemConfigUpdate = (payload?: any): actions.SystemConfigUpdate => {
    return {
        type: actions.SYSTEM_CONFIG_UPDATE,
        payload
    }
}

export const systemConfigProcessSuccess = (payload: any): actions.SystemConfigProcessSuccess => {
    return {
        type: actions.SYSTEM_CONFIG_PROCESS_SUCCESS,
        payload
    }
}

export const systemConfigDataSourceUpdate = (value: any): actions.SystemConfigDataSouceSuccess => {
    return {
        type: actions.SYSTEM_CONFIG_DATASOURCE_SUCCESS,
        payload: value
    }
}

export const systemConfigPrepareUpdate = (value:any): actions.SystemConfigPrepareUpdate=>{
    return {
        type: actions.SYSTEM_CONFIG_PREPARE_UPDATE,
        payload:value
    }
}

export const systemConfigSystemDateSet = (value:any):actions.SystemConfigSystemDateSet =>{
    return {
        type: actions.SYSTEM_CONFIG_SYSTEM_DATE_SET,
        payload: value
    }
}

export const systemConfigProcessReset = () => {
    return {
        type: actions.SYSTEM_CONFIG_PROCESS_RESET
    }
}

export const systemConfigPrepareUpdateReset = () => {
    return {
        type: actions.SYSTEM_CONFIG_PREPARE_UPDATE_RESET
    }
}

export const systemConfigReset = () => {
    return {
        type: actions.SYSTEM_CONFIG_RESET
    }
}
